import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { ReactivateCardHolderPopup } from "layouts/card-holder/popups/reactivateCardHolderPopup.tsx"
import { AddCardHolderPopup } from "layouts/card-holder/popups/addCardHolderPopup"
import { DeactivateCardHolderPopup } from "layouts/card-holder/popups/deactivateCardHolderPopup.tsx"
import { UpdateCardHolderPopup } from "layouts/card-holder/popups/updateCardHolderPopup.tsx"
import { useState } from "react"
import { Alert, Snackbar, Portal, Box } from "@mui/material"
export const CardHolderPopups = () => {
    const {
        openAddCardHolder,
        openActivateCardHolder,
        openDeactivateCardHolder,
        openUpdateCardHolder,
    } = useCardHolderContext()

    const [vidErrors, setVidErrors] = useState<string[]>([])

    return (
        <>
            {openAddCardHolder && (
                <AddCardHolderPopup
                    onVidCreationError={(vids) => setVidErrors(vids)}
                />
            )}

            {openActivateCardHolder && <ReactivateCardHolderPopup />}
            {openDeactivateCardHolder && <DeactivateCardHolderPopup />}
            {openUpdateCardHolder && <UpdateCardHolderPopup
                onVidCreationError={(vids) => setVidErrors(vids)}
            />}

            <Portal container={document.body}>
                <Snackbar
                    open={vidErrors.length > 0}
                    autoHideDuration={15000}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    onClose={(_, reason) => {
                        if (reason === "clickaway") return
                        setVidErrors([])
                    }}
                    data-cy="vid-error-snackbar"
                >
                    <Alert
                        severity="error"
                        variant="filled"
                        onClose={() => setVidErrors([])}
                        sx={{ width: "100%" }}
                        data-cy="vid-error-alert"
                    >
                        <Box>
                            <Box sx={{ mb: 0.5 }}>
                                Une erreur s'est produite lors de la création des VID suivants:
                            </Box>

                            {vidErrors.map((vid) => (
                                <Box key={vid} sx={{ pl: 1 }}>
                                    {vid}
                                </Box>
                            ))}
                        </Box>
                    </Alert>
                </Snackbar>
            </Portal>
        </>
    )
}